export default __webpack_public_path__ + "static/media/logo1.f5da1df4.png";